import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const virtualizedListContainerSx = {
  position: 'relative',
  width: '100%',
} satisfies SystemStyleObject<Theme>;

export const virtualizedListRowSx = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
} satisfies SystemStyleObject<Theme>;
